import { InboxPageLayout, Loader } from 'components/inbox/commons';
import ConversationDetail, { Container } from 'components/inbox/ConversationDetail';
import ConversationsPanel from 'components/inbox/ConversationsPanel';
import useConversationDetail from 'components/inbox/hooks/useConversationDetail';
import DefaultLayout from 'components/layouts/DefaultLayout';
import BookingPanel from 'components/inbox/bookingPanel/BookingPanel';
import { useSyncActiveConversationWithQuery } from 'components/inbox/hooks/useSyncActiveConversationWithQuery';
import { useAtomValue } from 'jotai';
import { activeTabNameAtom } from 'components/inbox/store';
import { TabNames } from 'components/inbox/constants';
import { getItunesAppUniversalLinkMetaTag, RENTER_APP_ID } from 'helpers/templateHelpers';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { initFirebase } from 'stacks/messaging/Firebase';

initFirebase();

export default function InboxPage() {
  useSyncActiveConversationWithQuery();
  const router = useRouter();
  const { isLoading, isIdle, isError } = useConversationDetail();
  const activeTabName = useAtomValue(activeTabNameAtom);

  useEffect(() => {
    document.body.classList.add('messagingBody');

    return () => {
      document.body.classList.remove('messagingBody');
    };
  }, []);

  return (
    <DefaultLayout
      isHome={activeTabName !== TabNames.owner && activeTabName !== TabNames.captain}
      ownerNav={activeTabName === TabNames.owner}
      captainNav={activeTabName === TabNames.captain}
      name="messaging"
      isProtected
      hideFooter
      white
    >
      <Head>
        {getItunesAppUniversalLinkMetaTag(router.asPath, RENTER_APP_ID)}
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
      </Head>
      <InboxPageLayout>
        <ConversationsPanel />
        {isLoading || isIdle || isError ? (
          <Container>{!isIdle && <Loader height="100%" />}</Container>
        ) : (
          <>
            <ConversationDetail />
            <BookingPanel />
          </>
        )}
      </InboxPageLayout>
    </DefaultLayout>
  );
}
